<template>
    <div class="container-fluid">
        <dropdown class="chart-ctrl">
          <btn type="primary" class="dropdown-toggle">Chart Type <span class="caret"></span></btn>
          <template slot="dropdown">
            <li @click="select(chartType) " v-for="(chartType, chartLabel) in chartViewer" :key="chartLabel"><a role="button">{{ chartLabel }}</a></li>
          </template>
        </dropdown>
    </div>
        
</template>

<script>
    import store from '../../store.js';
    export default {
        props: {
            columns: {default: 3},
            colors: {default: () => []},
        },
        data () {
            return {
                charts: {
                    'Line': 'line',
                    'Column': 'column',
                    'Bar': 'bar',
                    'Pie': 'pie',
                    'Area': 'area',
                    'Map': 'map'
                }

            }
        },
        computed: {
            chartViewer: function () {
                let dataType = store.state.dataType;
                if (dataType === 'xlsx' || dataType === 'xls'){
                    delete this.charts['Map']
                }
                return this.charts;
            }
        },
        methods: {
            select: function (chart) {
                console.log(chart);
                store.dispatch('setDisplayType', chart);

            }

        }
    }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/report/SelectChartType.vue